// assets
import { LoginOutlined, ProfileOutlined , PlusCircleOutlined, BookOutlined,
  OrderedListOutlined
} from '@ant-design/icons';

// icons
const icons = {
  LoginOutlined,
  ProfileOutlined,BookOutlined,OrderedListOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
  id: 'authentication',
  title: 'Authentication',
  type: 'group',
  children: [
    {
      id: 'master-tab',
      title: 'Customer & Mill Details',
      type: 'item',
      url: '/dashboard/master-tab',
      icon: icons.BookOutlined,
      // target: true
    },
    {
      id: 'Inspection-List',
      title: 'Inspection List',
      type: 'item',
      url: '/dashboard/inspection-list',
      icon: icons.OrderedListOutlined,
      // target: true
    },
    {
      id: 'user-list',
      title: 'Users List',
      type: 'item',
      url: '/users',
      icon: icons.ProfileOutlined,
      role: 'admin'   // 👈 only show for admin
    
    }
  ]

  

};


export default pages;
